import { render, staticRenderFns } from "./zzkj.vue?vue&type=template&id=20a00bcc"
import script from "./zzkj.vue?vue&type=script&lang=js"
export * from "./zzkj.vue?vue&type=script&lang=js"
import style0 from "./zzkj.vue?vue&type=style&index=0&id=20a00bcc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports